/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ResponseListUploadFilesVo,
  ResponseString,
  ResponseUploadFilesVo,
} from '../models/index';
import {
    ResponseListUploadFilesVoFromJSON,
    ResponseListUploadFilesVoToJSON,
    ResponseStringFromJSON,
    ResponseStringToJSON,
    ResponseUploadFilesVoFromJSON,
    ResponseUploadFilesVoToJSON,
} from '../models/index';

export interface UploadFilesIdDeleteRequest {
    id: number;
}

export interface UploadFilesIdGetRequest {
    id: number;
}

export interface UploadFilesListGetRequest {
    usageType: string;
}

export interface UploadFilesUploadBatchPostRequest {
    usageType: string;
    files: Blob;
}

export interface UploadFilesUploadPostRequest {
    usageType: string;
    file: Blob;
}

/**
 * 
 */
export class UploadFilesControllerApi extends runtime.BaseAPI {

    /**
     * 
     * 删除文件
     */
    async uploadFilesIdDeleteRaw(requestParameters: UploadFilesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uploadFilesIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/uploadFiles/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 删除文件
     */
    async uploadFilesIdDelete(requestParameters: UploadFilesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.uploadFilesIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取文件信息
     */
    async uploadFilesIdGetRaw(requestParameters: UploadFilesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUploadFilesVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling uploadFilesIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/uploadFiles/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUploadFilesVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取文件信息
     */
    async uploadFilesIdGet(requestParameters: UploadFilesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUploadFilesVo> {
        const response = await this.uploadFilesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 按使用场景获取文件列表
     */
    async uploadFilesListGetRaw(requestParameters: UploadFilesListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListUploadFilesVo>> {
        if (requestParameters['usageType'] == null) {
            throw new runtime.RequiredError(
                'usageType',
                'Required parameter "usageType" was null or undefined when calling uploadFilesListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['usageType'] != null) {
            queryParameters['usageType'] = requestParameters['usageType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/uploadFiles/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListUploadFilesVoFromJSON(jsonValue));
    }

    /**
     * 
     * 按使用场景获取文件列表
     */
    async uploadFilesListGet(requestParameters: UploadFilesListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListUploadFilesVo> {
        const response = await this.uploadFilesListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 批量上传文件
     * 页面上多个文件同时上传
     */
    async uploadFilesUploadBatchPostRaw(requestParameters: UploadFilesUploadBatchPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListUploadFilesVo>> {
        if (requestParameters['usageType'] == null) {
            throw new runtime.RequiredError(
                'usageType',
                'Required parameter "usageType" was null or undefined when calling uploadFilesUploadBatchPost().'
            );
        }

        if (requestParameters['files'] == null) {
            throw new runtime.RequiredError(
                'files',
                'Required parameter "files" was null or undefined when calling uploadFilesUploadBatchPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['usageType'] != null) {
            queryParameters['usageType'] = requestParameters['usageType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['files'] != null) {
            formParams.append('files', requestParameters['files'] as any);
        }

        const response = await this.request({
            path: `/uploadFiles/uploadBatch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListUploadFilesVoFromJSON(jsonValue));
    }

    /**
     * 批量上传文件
     * 页面上多个文件同时上传
     */
    async uploadFilesUploadBatchPost(requestParameters: UploadFilesUploadBatchPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListUploadFilesVo> {
        const response = await this.uploadFilesUploadBatchPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 上传文件
     */
    async uploadFilesUploadPostRaw(requestParameters: UploadFilesUploadPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUploadFilesVo>> {
        if (requestParameters['usageType'] == null) {
            throw new runtime.RequiredError(
                'usageType',
                'Required parameter "usageType" was null or undefined when calling uploadFilesUploadPost().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling uploadFilesUploadPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['usageType'] != null) {
            queryParameters['usageType'] = requestParameters['usageType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/uploadFiles/upload`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUploadFilesVoFromJSON(jsonValue));
    }

    /**
     * 
     * 上传文件
     */
    async uploadFilesUploadPost(requestParameters: UploadFilesUploadPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUploadFilesVo> {
        const response = await this.uploadFilesUploadPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
